module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_background_image3.a111e8ed.svg";